
export const maplayerSelector:string = [
'	<div class="btn-group dropdown d-inline-block me-5 float-end">',
'	<button class="btn btn-secondary btn-sm dropdown-toggle rounded-pill mt-3" type="button" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Map Type</button>',
'	<div class="dropdown-menu my-1">',
'	  <a class="dropdown-item active" href="#" setMapLayer="" layerId="main">Default</a>',
'	  <a class="dropdown-item" href="#" setMapLayer="" layerId="carnav">Basic</a>',
'	  <a class="dropdown-item" href="#" setMapLayer="" layerId="sat">Satellite</a>',
'	</div>',
'  </div>'
].join("\n");

export const routeWarning_template:string = [
'<div id="routeIssueWarningPopup" style="max-width:25vw;">',
'	<div class="card card-hover p-3 rounded">',
'		<div class="card-header d-flex align-items-center justify-content-between">',
'				<h5 class="mb-0">Route Warning</h5>',
'				<button id="routeWarning-close" class="btn-close pt-3 float-end" type="button"></button>',
'		</div>',
'		<div class="card-body d-flex align-items-center flex-wrap">',
'			<h6 style="font-weight:400;margin-bottom:0;">{{{ warningText }}}</h6>',
'		</div>',
'	</div>',
'	<div class="bottomLeftTriangle mt-n4" style="left:1px;top:12px;position:relative;"></div>',
'</div>'
].join("\n");

export const poiCard_template:string = [
'<div class="d-flex flex-row mb-1" stoppoielement="stopPoiElement" leg="{{ legIndex }}" stop="{{ stopIndex }}" poiID="{{ id }}">',
'	<div class="d-flex flex-column ps-3 agStayLine" style="width:10%;padding-bottom:2.5rem;">',
'		<div class="d-flex flex-row w-100 h-100">',
'			<div class="d-flex w-50 h-100 rightBorderLine"></div>',
'			<div class="d-flex w-50 h-100"></div>',
'		</div>',
'			<div class="d-flex flex-row w-100 h-100">',
'			<div class="d-flex w-50 h-100 rightBorderLine"></div>',
'			<div class="d-flex w-50 h-100 bottomBorderLine"></div>',
'		</div>',
'	</div>',
'	<div class="d-flex flex-column h-100 mt-3 UQcheck" poicardwrapper="poiCardWrapper" style="width:90%">',
'		<div class="card card-hover p-3 rounded rounded-bottom-0">',
'			<div class="gap-1 justify-content-between d-flex flex-row justify-content-between zindex-1" poiID="{{ id }}">',
'				<div class="d-flex flex-column justify-content-center" style="width:75%;">',
'					<h6 style="margin-bottom:0;">{{ name }}</h6>',
'					<div class="d-flex flex-row align-items-center">',
'						<h6 style="font-weight:400;margin-bottom:0;">{{ addr }}</h6>',
'					</div>',
'				</div>',
'				<a data-bs-toggle="tooltip" data-bs-placement="right" title="Remove POI" role="button" rem-poi-from-stop="rem-poi-from-stop" leg="{{ legIndex }}" stop="{{ stopIndex }}" poiID="{{ id }}"><i class="ai-trash-2 agIcon ps-1" style="padding-bottom:.125rem"></i></a>',
'			</div>',
'		</div>',
'	</div>',
'</div>'
].join("\n")

export const poiCard_template_sidebar:string = [
	'<div class="d-flex flex-row mb-1 w-100 justify-content-center" stoppoielementsidebar="stopPoiElementSidebar" leg="{{ legIndex }}" stop="{{ stopIndex }}" poiID="{{ id }}">',
	'	<div class="d-flex flex-column h-100 mt-3 UQcheck" style="width:90%">',
	'		<div class="card card-hover p-3">',
	'			<div class="gap-1 justify-content-between d-flex flex-row justify-content-between zindex-1" poiID="{{ id }}">',
	'				<div class="d-flex flex-column justify-content-center" style="width:75%;">',
	'					<h6 style="margin-bottom:0;">{{ name }}</h6>',
	'					<div class="d-flex flex-row align-items-center">',
	'						<h6 style="font-weight:400;margin-bottom:0;">{{ addr }}</h6>',
	'					</div>',
	'				</div>',
	'				<a data-bs-toggle="tooltip" data-bs-placement="right" title="Remove POI" role="button" rem-poi-from-stop="rem-poi-from-stop" leg="{{ legIndex }}" stop="{{ stopIndex }}" poiID="{{ id }}"><i class="ai-trash-2 agIcon ps-1" style="padding-bottom:.125rem"></i></a>',
	'			</div>',
	'		</div>',
	'	</div>',
	'</div>'
	].join("\n")

export const addedToStop_poiMapMarker_infoWindow:string = [
	'<div id="ol_map_poi_popup_card">',
	'	<div poiInfoCardWrapper="poiinfocardwrapper" style="width:300px;" class="card card-hover text-center" leg="{{ legIndex }}" stop="{{ stopIndex }}" poiID="{{ poiID }}" icon="{{ icon }}" loc="{{ loc }}">',
	'		<div class="card-header">',
	'			<button id="mapPoiInfoWindow-close" class="btn-close pt-3 float-end" type="button"></button>',
	'		</div>',
	'		<div class="card-body popup-card-body d-flex flex-column gap-2 justify-content-center align-items-center">',
	'			<div class="d-flex flex-column justify-content-center align-items-center">',
	'				<h5 class="card-title mb-2 mt-n1" poiName>{{ name }}</h5>',
	'				<p class="d-none" poiTypes>{{ poi_types }}</p>',
	'				<a href="{{ url }}" target="_blank" poiUrl>Visit Website</a>',
	'			</div>',
	'			<div class="d-flex flex-column gap-1 justify-content-center align-items-center">',
	'				<p class="text-muted mb-0 w-100" poiAddr>{{ street_address }}, {{ city }}, {{ administrative_area_level_1 }}</p>',
	'				<a rem-poi-from-stop="" leg="{{ legIndex }}" stop="{{ stopIndex }}" poiID="{{ poiID }}" style="width:200px;" class="breathingButton d-flex gap-1 flex-row mt-2 p-2 align-items-center justify-content-center btn btn-primary">',
	'					<h6 class="mb-0 fs-md text-white" style="font-weight:400;">Remove POI from stop</h6>',
	'				</a>',
	'			</div>',
	'		</div>',
	'	</div>',
	'	<div class="bottomLeftTriangle mt-n4" style="left:1px;top:12px;position:relative;"></div>',
	'</div>'
].join("\n")

export const addedToStop_poiMapMarker_infoWindow_NOURL:string = [
	'<div id="ol_map_poi_popup_card">',
	'	<div poiInfoCardWrapper="poiinfocardwrapper" style="width:300px;" class="card card-hover text-center" leg="{{ legIndex }}" stop="{{ stopIndex }}" poiID="{{ poiID }}" icon="{{ icon }}" loc="{{ loc }}">',
	'		<div class="card-header">',
	'			<button id="mapPoiInfoWindow-close" class="btn-close pt-3 float-end" type="button"></button>',
	'		</div>',
	'		<div class="card-body popup-card-body d-flex flex-column gap-2 justify-content-center align-items-center">',
	'			<div class="d-flex flex-column justify-content-center align-items-center">',
	'				<h5 class="card-title mb-2 mt-n1" poiName>{{ name }}</h5>',
	'				<p class="d-none" poiTypes>{{ poi_types }}</p>',
	'			</div>',
	'			<div class="d-flex flex-column gap-1 justify-content-center align-items-center">',
	'				<p class="text-muted mb-0 w-100" poiAddr>{{ street_address }}, {{ city }}, {{ administrative_area_level_1 }}</p>',
	'				<a rem-poi-from-stop="" leg="{{ legIndex }}" stop="{{ stopIndex }}" poiID="{{ poiID }}" style="width:200px;" class="breathingButton d-flex gap-1 flex-row mt-2 p-2 align-items-center justify-content-center btn btn-primary">',
	'					<h6 class="mb-0 fs-md text-white" style="font-weight:400;">Remove POI from stop</h6>',
	'				</a>',
	'			</div>',
	'		</div>',
	'	</div>',
	'	<div class="bottomLeftTriangle mt-n4" style="left:1px;top:12px;position:relative;"></div>',
	'</div>'
].join("\n")

export const addedToStop_poiMapMarker_infoWindow_NOADDR:string = [
	'<div id="ol_map_poi_popup_card">',
	'	<div poiInfoCardWrapper="poiinfocardwrapper" style="width:300px;" class="card card-hover text-center" leg="{{ legIndex }}" stop="{{ stopIndex }}" poiID="{{ poiID }}" icon="{{ icon }}" loc="{{ loc }}">',
	'		<div class="card-header">',
	'			<button id="mapPoiInfoWindow-close" class="btn-close pt-3 float-end" type="button"></button>',
	'		</div>',
	'		<div class="card-body popup-card-body d-flex flex-column gap-2 justify-content-center align-items-center">',
	'			<div class="d-flex flex-column justify-content-center align-items-center">',
	'				<h5 class="card-title mb-2 mt-n1" poiName>{{ name }}</h5>',
	'				<p class="d-none" poiTypes>{{ poi_types }}</p>',
	'			</div>',
	'			<div class="d-flex flex-column gap-1 justify-content-center align-items-center">',
	'				<p class="text-muted mb-0 w-100" poiAddr>{{ city }}, {{ administrative_area_level_1 }}</p>',
	'				<a rem-poi-from-stop="" leg="{{ legIndex }}" stop="{{ stopIndex }}" poiID="{{ poiID }}" style="width:200px;" class="breathingButton d-flex gap-1 flex-row mt-2 p-2 align-items-center justify-content-center btn btn-primary">',
	'					<h6 class="mb-0 fs-md text-white" style="font-weight:400;">Remove POI from stop</h6>',
	'				</a>',
	'			</div>',
	'		</div>',
	'	</div>',
	'	<div class="bottomLeftTriangle mt-n4" style="left:1px;top:12px;position:relative;"></div>',
	'</div>'
].join("\n")

export const addedToStop_poiMapMarker_infoWindow_NOURL_NOADDR:string = [
	'<div id="ol_map_poi_popup_card">',
	'	<div poiInfoCardWrapper="poiinfocardwrapper" style="width:300px;" class="card card-hover text-center" leg="{{ legIndex }}" stop="{{ stopIndex }}" poiID="{{ poiID }}" icon="{{ icon }}" loc="{{ loc }}">',
	'		<div class="card-header">',
	'			<button id="mapPoiInfoWindow-close" class="btn-close pt-3 float-end" type="button"></button>',
	'		</div>',
	'		<div class="card-body popup-card-body d-flex flex-column gap-2 justify-content-center align-items-center">',
	'			<div class="d-flex flex-column justify-content-center align-items-center">',
	'				<h5 class="card-title mb-2 mt-n1" poiName>{{ name }}</h5>',
	'				<p class="d-none" poiTypes>{{ poi_types }}</p>',
	'			</div>',
	'			<div class="d-flex flex-column gap-1 justify-content-center align-items-center">',
	'				<p class="text-muted mb-0 w-100" poiAddr>{{ city }}, {{ administrative_area_level_1 }}</p>',
	'				<a rem-poi-from-stop="" leg="{{ legIndex }}" stop="{{ stopIndex }}" poiID="{{ poiID }}" style="width:200px;" class="breathingButton d-flex gap-1 flex-row mt-2 p-2 align-items-center justify-content-center btn btn-primary">',
	'					<h6 class="mb-0 fs-md text-white" style="font-weight:400;">Remove POI from stop</h6>',
	'				</a>',
	'			</div>',
	'		</div>',
	'	</div>',
	'	<div class="bottomLeftTriangle mt-n4" style="left:1px;top:12px;position:relative;"></div>',
	'</div>'
].join("\n");

export const addedToStop_poiMapMarker_infoWindow_PHONE:string = [
	'<div id="ol_map_poi_popup_card">',
	'	<div poiInfoCardWrapper="poiinfocardwrapper" style="width:300px;" class="card card-hover text-center" leg="{{ legIndex }}" stop="{{ stopIndex }}" poiID="{{ poiID }}" icon="{{ icon }}" loc="{{ loc }}">',
	'		<div class="card-header">',
	'			<button id="mapPoiInfoWindow-close" class="btn-close pt-3 float-end" type="button"></button>',
	'		</div>',
	'		<div class="card-body popup-card-body d-flex flex-column gap-2 justify-content-center align-items-center">',
	'			<div class="d-flex flex-column justify-content-center align-items-center">',
	'				<h5 class="card-title mb-2 mt-n1" poiName>{{ name }}</h5>',
	'				<p class="d-none" poiTypes>{{ poi_types }}</p>',
	'				<p class="text-muted mb-0 w-100" poiPhone>{{ info_phone }}</p>',
	'				<a href="{{ url }}" target="_blank" poiUrl>Visit Website</a>',
	'			</div>',
	'			<div class="d-flex flex-column gap-1 justify-content-center align-items-center">',
	'				<p class="text-muted mb-0 w-100" poiAddr>{{ street_address }}, {{ city }}, {{ administrative_area_level_1 }}</p>',
	'				<a rem-poi-from-stop="" leg="{{ legIndex }}" stop="{{ stopIndex }}" poiID="{{ poiID }}" style="width:200px;" class="breathingButton d-flex gap-1 flex-row mt-2 p-2 align-items-center justify-content-center btn btn-primary">',
	'					<h6 class="mb-0 fs-md text-white" style="font-weight:400;">Remove POI from stop</h6>',
	'				</a>',
	'			</div>',
	'		</div>',
	'	</div>',
	'	<div class="bottomLeftTriangle mt-n4" style="left:1px;top:12px;position:relative;"></div>',
	'</div>'
].join("\n")

export const addedToStop_poiMapMarker_infoWindow_NOURL_PHONE:string = [
	'<div id="ol_map_poi_popup_card">',
	'	<div poiInfoCardWrapper="poiinfocardwrapper" style="width:300px;" class="card card-hover text-center" leg="{{ legIndex }}" stop="{{ stopIndex }}" poiID="{{ poiID }}" icon="{{ icon }}" loc="{{ loc }}">',
	'		<div class="card-header">',
	'			<button id="mapPoiInfoWindow-close" class="btn-close pt-3 float-end" type="button"></button>',
	'		</div>',
	'		<div class="card-body popup-card-body d-flex flex-column gap-2 justify-content-center align-items-center">',
	'			<div class="d-flex flex-column justify-content-center align-items-center">',
	'				<h5 class="card-title mb-2 mt-n1" poiName>{{ name }}</h5>',
	'				<p class="text-muted mb-0 w-100" poiPhone>{{ info_phone }}</p>',
	'				<p class="d-none" poiTypes>{{ poi_types }}</p>',
	'			</div>',
	'			<div class="d-flex flex-column gap-1 justify-content-center align-items-center">',
	'				<p class="text-muted mb-0 w-100" poiAddr>{{ street_address }}, {{ city }}, {{ administrative_area_level_1 }}</p>',
	'				<a rem-poi-from-stop="" leg="{{ legIndex }}" stop="{{ stopIndex }}" poiID="{{ poiID }}" style="width:200px;" class="breathingButton d-flex gap-1 flex-row mt-2 p-2 align-items-center justify-content-center btn btn-primary">',
	'					<h6 class="mb-0 fs-md text-white" style="font-weight:400;">Remove POI from stop</h6>',
	'				</a>',
	'			</div>',
	'		</div>',
	'	</div>',
	'	<div class="bottomLeftTriangle mt-n4" style="left:1px;top:12px;position:relative;"></div>',
	'</div>'
].join("\n")

export const addedToStop_poiMapMarker_infoWindow_NOADDR_PHONE:string = [
	'<div id="ol_map_poi_popup_card">',
	'	<div poiInfoCardWrapper="poiinfocardwrapper" style="width:300px;" class="card card-hover text-center" leg="{{ legIndex }}" stop="{{ stopIndex }}" poiID="{{ poiID }}" icon="{{ icon }}" loc="{{ loc }}">',
	'		<div class="card-header">',
	'			<button id="mapPoiInfoWindow-close" class="btn-close pt-3 float-end" type="button"></button>',
	'		</div>',
	'		<div class="card-body popup-card-body d-flex flex-column gap-2 justify-content-center align-items-center">',
	'			<div class="d-flex flex-column justify-content-center align-items-center">',
	'				<h5 class="card-title mb-2 mt-n1" poiName>{{ name }}</h5>',
	'				<p class="d-none" poiTypes>{{ poi_types }}</p>',
	'				<p class="text-muted mb-0 w-100" poiPhone>{{ info_phone }}</p>',
	'			</div>',
	'			<div class="d-flex flex-column gap-1 justify-content-center align-items-center">',
	'				<p class="text-muted mb-0 w-100" poiAddr>{{ city }}, {{ administrative_area_level_1 }}</p>',
	'				<a rem-poi-from-stop="" leg="{{ legIndex }}" stop="{{ stopIndex }}" poiID="{{ poiID }}" style="width:200px;" class="breathingButton d-flex gap-1 flex-row mt-2 p-2 align-items-center justify-content-center btn btn-primary">',
	'					<h6 class="mb-0 fs-md text-white" style="font-weight:400;">Remove POI from stop</h6>',
	'				</a>',
	'			</div>',
	'		</div>',
	'	</div>',
	'	<div class="bottomLeftTriangle mt-n4" style="left:1px;top:12px;position:relative;"></div>',
	'</div>'
].join("\n")

export const addedToStop_poiMapMarker_infoWindow_NOURL_NOADDR_PHONE:string = [
	'<div id="ol_map_poi_popup_card">',
	'	<div poiInfoCardWrapper="poiinfocardwrapper" style="width:300px;" class="card card-hover text-center" leg="{{ legIndex }}" stop="{{ stopIndex }}" poiID="{{ poiID }}" icon="{{ icon }}" loc="{{ loc }}">',
	'		<div class="card-header">',
	'			<button id="mapPoiInfoWindow-close" class="btn-close pt-3 float-end" type="button"></button>',
	'		</div>',
	'		<div class="card-body popup-card-body d-flex flex-column gap-2 justify-content-center align-items-center">',
	'			<div class="d-flex flex-column justify-content-center align-items-center">',
	'				<h5 class="card-title mb-2 mt-n1" poiName>{{ name }}</h5>',
	'				<p class="d-none" poiTypes>{{ poi_types }}</p>',
	'				<p class="text-muted mb-0 w-100" poiPhone>{{ info_phone }}</p>',
	'			</div>',
	'			<div class="d-flex flex-column gap-1 justify-content-center align-items-center">',
	'				<p class="text-muted mb-0 w-100" poiAddr>{{ city }}, {{ administrative_area_level_1 }}</p>',
	'				<a rem-poi-from-stop="" leg="{{ legIndex }}" stop="{{ stopIndex }}" poiID="{{ poiID }}" style="width:200px;" class="breathingButton d-flex gap-1 flex-row mt-2 p-2 align-items-center justify-content-center btn btn-primary">',
	'					<h6 class="mb-0 fs-md text-white" style="font-weight:400;">Remove POI from stop</h6>',
	'				</a>',
	'			</div>',
	'		</div>',
	'	</div>',
	'	<div class="bottomLeftTriangle mt-n4" style="left:1px;top:12px;position:relative;"></div>',
	'</div>'
].join("\n");

export const poiTypeSidebarDisp:string = [
'<div id="sidebarPOIwrap-{{ poi_type }}" class="d-flex flex-column justify-content-center">',
'	<div class="h5 mb-0 text-center collchev-y" href="#poiCollapse-{{ poi_type }}" data-bs-toggle="collapse" role="button" aria-expanded="true" aria-controls="poiCollapse-{{ poi_type }}">',
'	{{ poi_type_pretty }}',
'	<i class="ai-chevron-up"/>',
'	</div>',
'	<div id="poiCollapse-{{ poi_type }}" class="collapse show">',
'		<div poiList_inner="poilistinner" class="d-flex flex-wrap justify-content-center"></div>',
'	</div>',
'</div>',
].join("\n");

export const reviewImg:string = [
'<div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 px-0" style="margin:.25rem;">',
'	<img class="expandable-img h-100" style="object-fit:cover;border-radius:.25rem;" src="{{{ img_src }}}"/>',
'</div>'
].join("\n");

export const campImgCarousel_ImgTemplate = [
'<div class="carousel-inner">',
'	<div class="carousel-item">',
'		<img src="{{img_src}}" class="rounded expandable-img" style="max-height:20vh;"/>',
'	</div>',
'</div>'
].join("\n");

export const campMapMarker_infoWindow_s2n:string = [
'<div id="ol_map_popup_card" style="width:300px;" class="card card-hover text-center" leg="{{ legIndex }}" stop="{{ stopIndex }}" campID="{{ campID }}">',
' <div class="card-header">',
'	<button id="mapInfoWindow-close" class="btn-close pt-3 float-end" type="button"></button>',
'	<div class="d-flex pt-1 flex-row align-items-center justify-content-center">',
'		<i class="ai-star" style="padding-bottom:.125rem;"></i>',
'   	<p class="card-text">{{ genie_score }}</p>',
'	</div>',
' </div>',
' <div class="card-body camp-card-body popup-card-body d-flex flex-row justify-content-center" unselstay="" id="{{ campID }}" campID="{{ campID }}" href="{{ campPageURL }}">',
' <div class="d-flex flex-column gap-3 d-center">',
'		<h5 class="card-title mb-0 mt-n1">{{ camp_name }}</h5>',
'		<div class="d-flex flex-column align-items-center w-100 justify-content-center gap-2 h-50">',
'			<button style="width:200px;" class="btn btn-primary breathingButton d-flex fs-md p-2 align-items-center justify-content-center">View Campground</button>',
'			<a add-stay-to-stop="" style="width:200px;" leg="{{ legIndex }}" stop="{{ stopIndex }}" campID="{{ campID }}" class="breathingButton d-flex gap-1 flex-row p-2 align-items-center justify-content-center btn btn-primary">',
'				<i class="ai-plus-square fs-md" style="padding-top:.125rem;"></i>',
'				<h6 class="mb-0 fs-md text-white" style="font-weight:400;">Add Stay</h6>',
'			</a>',
'		</div>',
'		<div class="d-flex flex-row gap-1 d-center mt-1">',
'			<img id="s2n-logo" class="containImage" style="height:12px;" src="/static/images/s2n-logo-svg.svg"/>',
'		</div>',
'	</div>',
' </div>',
'<div class="bottomRightTriangle mt-n4" style="left:calc(100% - 29px);top:12px;position:relative;"></div>',
// ' <div class="card-footer fs-sm text-muted">',
// '	 <a id="mapInfoWindow-altStopBut" role="button" class="btn btn-sm btn-primary">View Alternative Stops</a>',
// ' </div>',
// '</div>'
].join("\n");

export const campMapMarker_infoWindow:string = [
'<div id="ol_map_popup_card" style="width:300px;" class="card card-hover text-center" leg="{{ legIndex }}" stop="{{ stopIndex }}" campID="{{ campID }}">',
' <div class="card-header">',
'	<button id="mapInfoWindow-close" class="btn-close pt-3 float-end" type="button"></button>',
'	<div class="d-flex pt-1 flex-row align-items-center justify-content-center">',
'		<i class="ai-star" style="padding-bottom:.125rem;"></i>',
'   	<p class="card-text">{{ genie_score }}</p>',
'	</div>',
' </div>',
' <div class="card-body camp-card-body popup-card-body d-flex flex-row justify-content-center" unselstay="" id="{{ campID }}" campID="{{ campID }}" href="{{ campPageURL }}">',
' <div class="d-flex flex-column gap-3 d-center">',
'		<h5 class="card-title mb-0 mt-n1">{{ camp_name }}</h5>',
'		<div class="d-flex flex-column align-items-center w-100 justify-content-center gap-2 h-50">',
'			<button style="width:200px;" class="btn btn-primary breathingButton d-flex fs-md p-2 align-items-center justify-content-center">View Campground</button>',
'			<a add-stay-to-stop="" style="width:200px;" leg="{{ legIndex }}" stop="{{ stopIndex }}" campID="{{ campID }}" class="breathingButton d-flex gap-1 flex-row p-2 align-items-center justify-content-center btn btn-primary">',
'				<i class="ai-plus-square fs-md" style="padding-top:.125rem;"></i>',
'				<h6 class="mb-0 fs-md text-white" style="font-weight:400;">Add Stay</h6>',
'			</a>',
'		</div>',
'	</div>',
' </div>',
'<div class="bottomRightTriangle mt-n4" style="left:calc(100% - 29px);top:12px;position:relative;"></div>',
// ' <div class="card-footer fs-sm text-muted">',
// '	 <a id="mapInfoWindow-altStopBut" role="button" class="btn btn-sm btn-primary">View Alternative Stops</a>',
// ' </div>',
// '</div>'
].join("\n");

export const campMapMarker_infoWindow_NOGENIESCORE_s2n:string = [
'<div id="ol_map_popup_card" style="width:300px;" class="card card-hover text-center" leg="{{ legIndex }}" stop="{{ stopIndex }}" campID="{{ campID }}">',
' <div class="card-header">',
'	<button id="mapInfoWindow-close" class="btn-close pt-3 float-end" type="button"></button>',
'	<div class="d-flex pt-1 flex-row align-items-center justify-content-center">',
'	</div>',
' </div>',
' <div class="card-body camp-card-body popup-card-body d-flex flex-row justify-content-center" unselstay="" id="{{ campID }}" campID="{{ campID }}" href="{{ campPageURL }}">',
' <div class="d-flex flex-column gap-3" style="height:fit-content;">',
'		<h5 class="card-title mb-0 mt-n1">{{ camp_name }}</h5>',
'		<div class="d-flex flex-column align-items-center w-100 justify-content-center gap-2 h-50">',
'			<button style="width:200px;" class="btn btn-primary breathingButton d-flex fs-md p-2 align-items-center justify-content-center">View Campground</button>',
'			<a add-stay-to-stop="" style="width:200px;" leg="{{ legIndex }}" stop="{{ stopIndex }}" campID="{{ campID }}" class="breathingButton d-flex gap-1 flex-row p-2 align-items-center justify-content-center btn btn-primary">',
'				<i class="ai-plus-square fs-md" style="padding-top:.125rem;"></i>',
'				<h6 class="mb-0 fs-md text-white" style="font-weight:400;">Add Stay</h6>',
'			</a>',
'		</div>',
'		<div class="d-flex flex-row gap-1 d-center mt-1">',
'			<img id="s2n-logo" class="containImage" style="height:12px;" src="/static/images/s2n-logo-svg.svg"/>',
'		</div>',
'	</div>',
' </div>',
'<div class="bottomRightTriangle mt-n4" style="left:calc(100% - 29px);top:12px;position:relative;"></div>',
// ' <div class="card-footer fs-sm text-muted">',
// '	 <a id="mapInfoWindow-altStopBut" role="button" class="btn btn-sm btn-primary">View Alternative Stops</a>',
// ' </div>',
// '</div>'
].join("\n");

export const campMapMarker_infoWindow_NOGENIESCORE:string = [
'<div id="ol_map_popup_card" style="width:300px;" class="card card-hover text-center" leg="{{ legIndex }}" stop="{{ stopIndex }}" campID="{{ campID }}">',
' <div class="card-header">',
'	<button id="mapInfoWindow-close" class="btn-close pt-3 float-end" type="button"></button>',
'	<div class="d-flex pt-1 flex-row align-items-center justify-content-center">',
'	</div>',
' </div>',
' <div class="card-body camp-card-body popup-card-body d-flex flex-row justify-content-center" unselstay="" id="{{ campID }}" campID="{{ campID }}" href="{{ campPageURL }}">',
' <div class="d-flex flex-column gap-3" style="height:fit-content;">',
'		<h5 class="card-title mb-0 mt-n1">{{ camp_name }}</h5>',
'		<div class="d-flex flex-column align-items-center w-100 justify-content-center gap-2 h-50">',
'			<button style="width:200px;" class="btn btn-primary breathingButton d-flex fs-md p-2 align-items-center justify-content-center">View Campground</button>',
'			<a add-stay-to-stop="" style="width:200px;" leg="{{ legIndex }}" stop="{{ stopIndex }}" campID="{{ campID }}" class="breathingButton d-flex gap-1 flex-row p-2 align-items-center justify-content-center btn btn-primary">',
'				<i class="ai-plus-square fs-md" style="padding-top:.125rem;"></i>',
'				<h6 class="mb-0 fs-md text-white" style="font-weight:400;">Add Stay</h6>',
'			</a>',
'		</div>',
'	</div>',
' </div>',
'<div class="bottomRightTriangle mt-n4" style="left:calc(100% - 29px);top:12px;position:relative;"></div>',
// ' <div class="card-footer fs-sm text-muted">',
// '	 <a id="mapInfoWindow-altStopBut" role="button" class="btn btn-sm btn-primary">View Alternative Stops</a>',
// ' </div>',
// '</div>'
].join("\n");

// export const stopByStop_newStopTemplate = [
// '<div class="presearchInputWrapper">',
// '<div class="row">',
// 	'<div class="col-1"></div>',
// 	'<div class="col-1 pe-0 w-auto h-auto d-flex align-items-center"><i class="ai-more-vertical"></i></div>',
// '</div>',
// '<div class="row stop">',
// 	'<div class="col-1"></div>',
// 	'<div class="col-1 pe-0 w-auto h-auto d-flex align-items-center"><i class="ai-map-pin"></i></div>',
// 	'<div class="col">',
// 		'<div class="d-flex flex-row align-items-center input-group agInputWrap">',
// 			'<i class="ai-search position-absolute ps-2" style="z-index:1;padding-bottom:.125rem;">',
// 			'</i>',
// 			'<input style="padding-right:2.25rem;border-radius:.75rem!IMPORTANT;" class="agInput agDSmin w-100 stop-by-stop-input" type="text" placeholder="Enter Location...">',
// 			'<i class="ai-trash breathingButton agIconHorange presearchInput end-0 position-absolute pe-3">',
// 			'</i>',
// 		'</div>',
// 	'</div>',
// 	'<div class="col-1"></div>',
// '</div>',
// '</div>'
// ].join("\n");

export const stopByStop_newStopTemplate = [
'<div class="input-group stopByStop_addStop">',
'	<span class="input-group-text stopByStop_addStop">',
'		<i class="ai-map-pin"></i>',
'	</span>',
'	<input class="form-control stop-by-stop-input border-start-0 stopByStop_addStop" type="text" autocomplete="off" />',
'	<span role="button" class="input-group-text">',
'		<i class="ai-trash breathingButton agIconHorange"></i>',
'	</span>',
'</div>'
].join("\n");

export const collapseSideBarTemplate = [
'<div style="transform: translate(0px, -100px); cursor:grab;" data-bs-toggle="tooltip" data-bs-placement="right" title="Close SideBar">',
'	<a href="#tripStopInfoSidebar" data-bs-toggle="collapse" role="button" aria-expanded="false" aria-controls="tripStopInfoSidebar" id="collapseSidebar" class="badge bg-secondary fs-lg ms-n3"><i class="ai-chevrons-left p-2 ms-1"></i></div>',
'</div>'
].join("\n");

export const remStopAlert_template = [
	'<div class="d-flex flex-wrap justify-content-center" id="remStopModal-stopInfo" style="gap:.5rem;" leg="{{ legIndex }}" stop="{{ stopIndex }}">',
	'	Remove Stop ',
	'	<div class="text-info text-center">{{{ name }}}</div>',
	'</div>'
].join("\n");

export const tripSidebar_timeDistDisp_endStop = [
	'<div class="h-25" style="width:0px;border-left:1px solid rgb(185,185,185)"></div>',
	'<i class="ai-map-pin"></i>'
].join("\n");

export const tripSidebar_timeDistDisp_startStop = [
'<i class="ai-stop-circle"></i>',
'<div class="h-100" style="width:0px;border-left:1px solid rgb(185,185,185)"></div>',
'<p class="fs-xs rot-text-270 mt-3 text-align-center travDat text-center">{{ distance }}mi {{ time }}</p>'
].join("\n");

export const tripSidebar_timeDistDisp_middleStop = [
'<div class="h-25" style="width:0px;border-left:1px solid rgb(185,185,185)"></div>',
'<i class="ai-stop-circle"></i>',
'<div class="h-75" style="width:0px;border-left:1px solid rgb(185,185,185)"></div>',
].join("\n");

export const addStopOptionsTemplate = [
'<div class="row addStop-buttons w-100 pt-1">',
'	<div class="d-flex flex-row align-items-center w-100 mb-2">',
'		<button class="col btn btn-primary showAddStopSearch h-100 me-1" style="white-space:break-spaces;">Search For Stop</button>',
'		<button class="col btn btn-primary showAddStopClusterUI h-100 mx-1" style="white-space:break-spaces;">Choose From Nearby</button>',
'		<button class="btn-close" type="button"></button>',
'	</div>',
'</div>'
].join("\n");

export const addStopSearchTemplate = [
'<form class="needs-validation addStopSearch d-flex flex-row w-100" novalidate>',
'	<div class="col stop">',
'		<div class="d-flex flex-row">',
'			<div class="col-1 pe-0 w-auto h-auto d-flex align-items-center">',
'				<i class="ai-map-pin"></i>',
'			</div>',
'			<div class="d-flex w-100 px-2">',
'				<input class="form-control stop-by-stop-input" type="text" placeholder="Search For Stop" required/>',
'			</div>',
'			<div class="d-flex pe-2">',
'				<input type="submit" class="btn btn-sm btn-primary h-100" value="Search"/>',
'			</div>',
'		</div>',
'		<div class="row pt-2">',
'			<div id="addStopInput-autofill">',
'				<ul id="addStopInput-autofillResults" class="list-group"></ul>',
'			</div>',
'		</div>',
'	</div>',
'	<button class="btn-close pt-4 mt-1" type="button"></button>',
'</form>'
].join("\n");

export const campInfoCardTemplate = [
'<div id="{{ campID }}" class="card altStopInfo mx-2" style="min-width:25%;">',
'	<div class="card-body" id="{{ campID }}">',
'		<div class="dl ps-1">',
'			<div class="d-flex">',
'				<dt class="card-title mb-0">{{ camp_name }}</dt>',
'				<a class="ai-external-link" href="{{ site_url }}" target="_" data-bs-toggle="tooltip" data-bs-placement="right" title="Go To Camp Website"></a>',
'			</div>',
'			<dd class="mb-0 d-flex">',
'				<div class="camp-addr">{{ city }}, {{ administrative_area_level_1 }}</div>',
'				<i class="ai-info" data-bs-toggle="tooltip" data-bs-placement="right" title="GPS: {{ longitude }}/{{ latitude }}"></i>',
'			</dd>',
'		</div>',
'		<div class="d-flex mt-2 mx-1 w-100 mt-2">',
'			<button class="btn btn-primary me-1 add-s">Add Stop</button>',
'			<button class="btn btn-primary ms-1 repl-s">Replace A Stop</button>',
'		</div>',
'	</div>',
'</div>'
].join("\n");

export const mapLoadingIcon_genieJourneySearch = [
'<div id="mapLoadingIcon-genieJourneySearch" style="background-color:rgba(0, 0, 0, 0.5); height:100vh;width:100vw;" class="d-flex justify-content-center align-items-center flex-column">',
'		<h2 style="transform: translateY(-300%);font-weight: bold;" class="text-white">Sit tight while we create your adventure.</h2>',
'		<div style="height:10rem;width:10rem;border-width:2rem;" class="spinner-border text-primary zindex-5 position-absolute" role="status">',
'			<span class="visually-hidden">Loading...</span>',
'		</div>',
'		<h5 style="transform: translateY(250%);font-style: italic;width: fit-content;" class="text-white text-center">You can find your itinerary in the <br> "Activities" section of each stop.</h5>',
'</div>'
].join("\n");

export const mapLoadingIcon = [
'<div id="mapLoadingIcon" class="d-flex flex-column justify-content-center align-items-center" style="background-color:rgba(0, 0, 0, 0.5); height:100vh;width:100vw;">',
' 	<div style="height:10rem;width:10rem;border-width:2rem;" class="spinner-border text-primary zindex-5" role="status">',
'		<span class="visually-hidden">Loading...</span>',
'	</div>',
'	<div id="mapLoadingText" class="text-xxl text-white">Creating your trip!</div>',
'</div>',
].join("\n");

export const loadingIcon = [
	'<div id="ag-loadingIcon" class="position-relative mobile-mt-4 top-0 w-100 d-flex d-center" style="min-height:100px;">',
	' <div class="spinner-border text-warning zindex-5 position-absolute" role="status">',
	'	 <span class="visually-hidden">Loading...</span>',
	' </div>',
	'</div>'
	].join("\n");

export const review_dispTemplate = [
'<div reviewWrap="" class="mb-3 d-flex flex-column">',
'<div class="position-absolute" style="background-position:center;background-repeat:no-repeat;height: 32px;transform: translate(-16px, -16px);width: 32px;background-image:url(/static/images/JUSTtheSTARS_orange.svg);"></div>',
'	<div class="camp-review border p-2 rounded" id={{ _id.$oid }}>',
'		<div class="review-img-wrap d-flex mb-3" style="overflow-x:scroll;width:fit-content;"></div>',
'		<div class="cID" id={{ campID }}></div>',
'  		<div class="float-end editReviewWrap me-1"></div>',
'		<div class="float-end addReviewImgWrap"></div>',
'		<div id="existingReview-addImg-err"></div>',
'   	<div class="d-flex align-items-center me-3">',
'			<img class="rounded-circle" src="/static/images/icons/AG_user_icon.svg" alt="Profile Img" width="42"/>',
'	 		<div class="ms-2 p-2 d-flex flex-column gap-1 ms-1">',
'				<h6 class="fs-sm mb-n1 dispName">{{ disp_name }}</h6><span class="fs-xs text-muted">{{ timeDiffMsg }}</span>',
'				<div class="d-sm-flex align-items-center pb-1">',
'		 			<div class="star-rating-lg star-rating mt-n1">',
'			 			{{{stars_html}}}',
'		 			</div>',
'					<div class="d-flex align-items-center">',
'	 				</div>',
'				</div>',
'			</div>',
'		</div>',
' 		<p class="fs-md pt-2 ps-2 mb-0" id="review_text">{{{ text }}}</p>',
' 		<div id="reviewReply_{{ _id.$oid }}" class="d-flex my-2 py-2 rounded align-items-center justify-content-center agButtonReply review-reply-but flex-row gap-1">',
'				<h6 class="mb-0 c-orange" style="font-weight:400;">Reply</h6>',
' 			<i class="ai-corner-up-right" style="rotate:90deg;"></i>',
'			</div>',
' 	</div>',
'	<div class="review-edit-wrapper" style="display:none;"></div>',
//'<div class="borderLine w-50 mx-auto mt-2"></div>',
'</div>'
].join("\n");

export const reply_dispTemplate = [
'<div class="border-start ps-2 pt-4 ms-3 camp-review d-flex flex-column" id={{ _id.$oid }}>',
' <div class="cID" id={{ campID }}></div>',
' <div class="d-flex align-items-center me-3"><img class="rounded-circle" src="/static/images/icons/AG_user_icon.svg" alt="Profile Img" width="42"/>',
'	<div class="ps-2 ms-1">',
'		<h6 class="fs-sm mb-n1 dispName">{{ disp_name }}</h6><span class="fs-xs text-muted">{{ timeDiffMsg }}</span>',
'		<div class="d-sm-flex align-items-center mb-2 pb-1">',
'		 <div class="star-rating-lg mb-3 mb-sm-0 me-sm-2 star-rating mt-n1">',
'			 {{{stars_html}}}',
'		 </div>',
'		<div class="d-flex align-items-center">',
'	 </div>',
'	</div>',
'	</div>',
' </div>',
' <p class="fs-md pt-2 ps-2 mb-0" id="review_text">{{ text }}</p>',
' <div id="reviewReply_{{ _id.$oid }}" class="d-flex my-2 py-2 rounded align-items-center justify-content-center agButtonReply review-reply-but flex-row gap-1">',
'		<h6 class="mb-0 c-orange" style="font-weight:400;">Reply</h6>',
' 	<i class="ai-corner-up-right" style="rotate:90deg;"></i>',
'	</div>',
'</div>'
].join("\n");

export const newReply_dispTemplate = [
'<form class="needs-validation submitReviewReply" novalidate="novalidate" id="{{ replyTo_reviewID }}">',
	'<div class="mb-3 p-3 rounded card card-hover bg-secondary">',
		'<div class="d-flex flex-row mb-3 align-items-center justify-content-around">',
		'	<div></div>',
		'	<label class="w-100 text-center" for="review-text">Replying to {{ replyTo_dispName }}<span class="text-danger">*</span></label>',
		'	<a class="btn-close" replyButtonClose="" replyToID="{{ replyTo_reviewID }}"></a>',
		'</div>',
		'<textarea class="form-control" rows="6" required="required" id="review-text"></textarea>',
		'<button class="btn mt-2 btn-primary btn-shadow d-block w-100" type="submit" id="submitCampReviewReply">Submit Reply</button>',
	'</div>',
'</form>'
].join("\n");

export const review_emptyStar = [
'<i class="sr-star ai-star-filled"></i>'
];

export const review_activeStar = [
'<i class="sr-star ai-star-filled active"></i>'
];

export const uploadIconElement = [
'<span id={{ _id.$oid }}>',
'	<button class="agIconHorange reviewButton ai-upload d-none"></button>',
'	<input type="file" class="addReviewImage d-none" accept=".png,.jpg,.jpeg" multiple></input>',
'</span>'
].join("\n");

export const folderIconTemplate = [
'<div class="flex-row folderIconWrap folder-drop-target d-flex flex-row" folder_id={{ folderID }}>',
'	<button folder_id="{{ folderID }}" type="button" style="border-radius:0;min-width:15vw;margin-bottom:0;" class="btn border-primary text-primary h2 folderSwitchable expandFolder">',
'		<i class="ai-folder" style="font-size:2rem;"></i>',
'		<span class="foldername">{{ folderName }}',
'			<span class="folder-count d-inline-block align-middle bg-faded-dark fs-ms fs-medium rounded-1 py-1 px-2 mb-1 ms-1">{{ itemCount }}</span>',
'		</span>',
'	</button>',
'	<button folder_id={{ folderID }} type="button" class="deleteFolder end-0 btn agIconHorange rounded-0 px-1" data-bs-toggle="tooltip" data-bs-placement="top" title="Delete {{ folderName }}">',
'	<i class="ai-trash-2"></i>',
'	</button>',
'</div>'
].join("\n");

export const campCardPlaceholder = [
'<div class="h-25 w-25 draggable-camp-placeholder" id="{{ id }}">',
'	<div class="card text-primary border-primary card-product w-25 h-50">',
'		<div class="id" id="{{ id }}">',
'			<h5 class="card-title placeholder-glow"><span class="placeholder col-6"></span></h5>',
'			<p class="card-text placeholder-glow">',
'				<span class="placeholder placeholder-sm col-4 me-2"></span>',
'			</p>',
'		</div>',
'	</div>',
'</div>'
].join("\n");



export const autofillTemplate:string = [
'<div class="autofill_suggestion_wrap list-group-item list-group-item-action d-flex">',
'<div class="autofill_types d-none">{{ types }}</div>',
'<div class="d-flex flex-row w-100" style="justify-content:flex-start;">',
'	<div class="d-flex h-100 align-items-center">',
'		<div class="autofill_bgImg_wrap pe-3">',
'			<i class="ai-search"></i>',
'		</div>',
'	</div>',
'	<a role="button" class="autofill_predictionDesc stretched-link">{{ description }}</a>',
' </div>',
' <div class="autofill_suggestion d-none">{{ suggestion }}</div>',
'</div>'
].join("\n");

export const cgSearchAutofillTemplate:string = [
	'<div class="autofill_suggestion_wrap list-group-item list-group-item-action d-flex">',
	'<div class="autofill_types d-none"></div>',
	'<a role="button" class="autofill_predictionDesc stretched-link"></a>',
	' <div class="autofill_bgImg_wrap">',
	'	 <img src="./static/images/icons/icons8-search-24.webp">',
	' </div>',
	' <div class="autofill_suggestion d-none">{{ prediction }}</div>',
	'</div>'
	].join("\n");

export const friendList_dispTemplate = [
	'<div class="d-md-flex align-items-center py-grid-gutter border-bottom">',
	' <div class="d-flex align-items-center me-md-4 mb-4 mb-md-0" style="max-width: 264px;"><a class="d-block" href="#"><img class="d-block rounded-circle" src=src="{{url_for(`static`, filename=`images/icons/person-profile-image.webp`)}}" alt="user image" width="90"></a>',
	'	 <div class="ps-3">',
	'		 <h2 class="fs-base nav-heading mb-1"><a href="#">{{ friend.name }}</a></h2>',
	'		 <div class="fs-xs text-muted mb-2 pb-1">@{{ friend.username }}</div>',
	'		 <div class="d-none">',
	'			 {{ friend.uid }}',
	'		 </div>',
	'	 </div>',
	' </div>',
	'</div>'
	].join("\n");

export const tripPlanner_loading_template = [
'	<div class="card border-0 shadow m-3 p-3" aria-hidden="true">',
'		<div class="position-relative placeholder-wave">',
'			<div class="card-img-top placeholder ratio ratio-16x9"></div><i class="ai-image position-absolute top-50 start-50 translate-middle fs-1 opacity-50"></i>',
'		</div>',
'		<div class="card-body">',
'			<h5 class="card-title placeholder-glow"><span class="placeholder col-6"></span></h5>',
'			<p class="card-text placeholder-glow"><span class="placeholder placeholder-sm col-7 me-2"></span><span class="placeholder placeholder-sm col-4"></span><span class="placeholder placeholder-sm col-4 me-2"></span><span class="placeholder placeholder-sm col-6"></span><span class="placeholder placeholder-sm col-8"></span></p><a class="btn btn-primary disabled placeholder col-6 placeholder-wave" href="#" tabindex="-1"></a>',
'		</div>',
'	</div>',
'	<div class="card border-0 shadow m-3 p-3" aria-hidden="true">',
'		<div class="position-relative placeholder-wave">',
'			<div class="card-img-top placeholder ratio ratio-16x9"></div><i class="ai-image position-absolute top-50 start-50 translate-middle fs-1 opacity-50"></i>',
'		</div>',
'		<div class="card-body">',
'			<h5 class="card-title placeholder-glow"><span class="placeholder col-6"></span></h5>',
'			<p class="card-text placeholder-glow"><span class="placeholder placeholder-sm col-7 me-2"></span><span class="placeholder placeholder-sm col-4"></span><span class="placeholder placeholder-sm col-4 me-2"></span><span class="placeholder placeholder-sm col-6"></span><span class="placeholder placeholder-sm col-8"></span></p><a class="btn btn-primary disabled placeholder col-6 placeholder-wave" href="#" tabindex="-1"></a>',
'		</div>',
'	</div>',
'	<div class="card border-0 shadow m-3 p-3" aria-hidden="true">',
'		<div class="position-relative placeholder-wave">',
'			<div class="card-img-top placeholder ratio ratio-16x9"></div><i class="ai-image position-absolute top-50 start-50 translate-middle fs-1 opacity-50"></i>',
'		</div>',
'		<div class="card-body">',
'			<h5 class="card-title placeholder-glow"><span class="placeholder col-6"></span></h5>',
'			<p class="card-text placeholder-glow"><span class="placeholder placeholder-sm col-7 me-2"></span><span class="placeholder placeholder-sm col-4"></span><span class="placeholder placeholder-sm col-4 me-2"></span><span class="placeholder placeholder-sm col-6"></span><span class="placeholder placeholder-sm col-8"></span></p><a class="btn btn-primary disabled placeholder col-6 placeholder-wave" href="#" tabindex="-1"></a>',
'		</div>',
'	</div>',
].join("\n");

export const selectedStayTemplate_sideMenu = [
	'	<div campStayElement="" leg="{{ legIndex }}" stop="{{ stopIndex }}" class="card p-2 mb-2" campID="{{ camp.campID }}">',
	'	<div class="card-body p-2 d-flex flex-row camp-card-body justify-content-between" leg="{{ legIndex }}" stop="{{ stopIndex }}" id="{{ camp.campID }}" href="/rv-campgrounds/{{ camp.administrative_area_level_1_long }}/{{ camp.city| quote_plus | lower | replace("+","-) }}/{{ camp.camp_name| quote_plus | lower | replace("+","-) }}">',
	'	  <a class="start-0 w-100 h-100 position-absolute zindex-0" onclick="return false" tab-index="-1" role="button" target="_blank" href="/rv-campgrounds/{{ camp.administrative_area_level_1_long }}/{{ camp.city| quote_plus | lower | replace("+","-) }}/{{ camp.camp_name| quote_plus | lower | replace("+","-) }}"></a>',
	'	  <div class="d-flex flex-column" style="width:70%;">',
	'		<h6 style="margin-bottom:0;">{{ camp.camp_name }}</h6>',
	'		<div class="d-flex flex-row align-items-center">',
	'		  <h6 class="fs-sm" style="font-weight:400;margin-bottom:0;">{{ camp.city }}, {{ camp.administrative_area_level_1 }}',
	'			</h6>',
	'		</div>',
	'	  </div>',
	'	  <div class="d-flex flex-row justify-content-end flex-wrap align-items-center">',
	'			<div class="d-flex flex-row align-items-center">',
	'				<img class="pe-1" src ="/static/images/icons/JUSTtheSTARS.svg" style="height:22px;pointer-events:none;"></img>',
	'				<h6 style="font-weight:400;margin-bottom:0;padding-top:.125rem;">{{ camp.genie_score }}</h6>',
	'			</div>',
	'			<div class="d-flex flex-row align-items-center ms-1">',
	'				<img class="pe-1" src ="/static/images/icons/genieMatch.svg" style="height:22px;pointer-events:none;"></img>',
	'				<h6 style="font-weight:400;margin-bottom:0;padding-top:.125rem;" class="campsite-match">{{ camp.genieMatch }}%</h6>',
	'			</div>',
	'		<a class="zindex-1" data-bs-toggle="tooltip" data-bs-placement="right" title="Remove Stay" role="button" removestaybutton="removeStayButton"><i style="padding-bottom:.125rem;" class="ai-trash-2 ps-1 agIcon"></i></a>',
	'	  </div>',
	'	</div>',
	'  </div>'
].join("\n");

export const selectedStayTemplate_sideMenu_S2N = [
	'	<div campStayElement="" leg="{{ legIndex }}" stop="{{ stopIndex }}" class="card p-2 mb-2" campID="{{ camp.campID }}">',
	'	<div class="card-body p-2 d-flex flex-row camp-card-body justify-content-between" leg="{{ legIndex }}" stop="{{ stopIndex }}" id="{{ camp.campID }}" href="/rv-campgrounds/{{ camp.administrative_area_level_1_long }}/{{ camp.city| quote_plus | lower | replace("+","-) }}/{{ camp.camp_name| quote_plus | lower | replace("+","-) }}">',
	'	  <a class="start-0 w-100 h-100 position-absolute zindex-0" onclick="return false" tab-index="-1" role="button" target="_blank" href="/rv-campgrounds/{{ camp.administrative_area_level_1_long }}/{{ camp.city| quote_plus | lower | replace("+","-) }}/{{ camp.camp_name| quote_plus | lower | replace("+","-) }}"></a>',
	'	  <div class="d-flex flex-column" style="width:70%;">',
	'		<h6 style="margin-bottom:0;">{{ camp.camp_name }}</h6>',
	'		<div class="d-flex flex-row align-items-center">',
	'		  <h6 class="fs-sm" style="font-weight:400;margin-bottom:0;">{{ camp.city }}, {{ camp.administrative_area_level_1 }}',
	'			</h6>',
	'		</div>',
	'	  </div>',
	'	  <div class="d-flex flex-row justify-content-end flex-wrap align-items-center">',
	'			<div class="d-flex flex-row align-items-center">',
	'				<img class="pe-1" src ="/static/images/icons/JUSTtheSTARS.svg" style="height:22px;pointer-events:none;"></img>',
	'				<h6 style="font-weight:400;margin-bottom:0;padding-top:.125rem;">{{ camp.genie_score }}</h6>',
	'			</div>',
	'			<div class="d-flex flex-row align-items-center ms-1">',
	'				<img class="pe-1" src ="/static/images/icons/genieMatch.svg" style="height:22px;pointer-events:none;"></img>',
	'				<h6 style="font-weight:400;margin-bottom:0;padding-top:.125rem;" class="campsite-match">{{ camp.genieMatch }}%</h6>',
	'			</div>',
	'		<a class="zindex-1" data-bs-toggle="tooltip" data-bs-placement="right" title="Remove Stay" role="button" removestaybutton="removeStayButton"><i style="padding-bottom:.125rem;" class="ai-trash-2 ps-1 agIcon"></i></a>',
	'	  </div>',
	'	</div>',
	' <div class="px-2 mt-n2 pb-2 d-flex justify-content-start w-100 align-items-start">',
	'		<img id="s2n-logo" class="containImage" style="height:12px;width:fit-content;" src="/static/images/s2n-logo-svg.svg">',
	'	</div>',
	'  </div>'
].join("\n");

export const selectedStayTemplate_sideMenu_NOGENIEMATCH = [
	'	<div campStayElement="" leg="{{ legIndex }}" stop="{{ stopIndex }}" class="card p-2 mb-2" campID="{{ camp.campID }}">',
	'	<div class="card-body p-2 d-flex flex-row camp-card-body justify-content-between" leg="{{ legIndex }}" stop="{{ stopIndex }}" id="{{ camp.campID }}" href="/rv-campgrounds/{{ camp.administrative_area_level_1_long }}/{{ camp.city| quote_plus | lower | replace("+","-) }}/{{ camp.camp_name| quote_plus | lower | replace("+","-) }}">',
	'	  <a class="start-0 w-100 h-100 position-absolute zindex-0" onclick="return false" tab-index="-1" role="button" target="_blank" href="/rv-campgrounds/{{ camp.administrative_area_level_1_long }}/{{ camp.city| quote_plus | lower | replace("+","-) }}/{{ camp.camp_name| quote_plus | lower | replace("+","-) }}"></a>',
	'	  <div class="d-flex flex-column" style="width:80%;">',
	'		<h6 style="margin-bottom:0;">{{ camp.camp_name }}</h6>',
	'		<div class="d-flex flex-row align-items-center">',
	'		  <h6 class="fs-sm" style="font-weight:400;margin-bottom:0;">{{ camp.city }}, {{ camp.administrative_area_level_1 }}',
	'			</h6>',
	'		</div>',
	'	  </div>',
	'	  <div class="d-flex flex-row justify-content-end flex-wrap align-items-center">',
	'			<div class="d-flex flex-row align-items-center">',
	'				<img class="pe-1" src ="/static/images/icons/JUSTtheSTARS.svg" style="height:22px;pointer-events:none;"></img>',
	'				<h6 style="font-weight:400;margin-bottom:0;padding-top:.125rem;">{{ camp.genie_score }}</h6>',
	'			</div>',
	'		<a class="zindex-1" data-bs-toggle="tooltip" data-bs-placement="right" title="Remove Stay" role="button" removestaybutton="removeStayButton"><i style="padding-bottom:.125rem;" class="ai-trash-2 ps-1 agIcon"></i></a>',
	'	  </div>',
	'	</div>',
	'  </div>'
].join("\n");

export const selectedStayTemplate_sideMenu_NOGENIEMATCH_S2N = [
	'	<div campStayElement="" leg="{{ legIndex }}" stop="{{ stopIndex }}" class="card p-2 mb-2" campID="{{ camp.campID }}">',
	'	<div class="card-body p-2 d-flex flex-row camp-card-body justify-content-between" leg="{{ legIndex }}" stop="{{ stopIndex }}" id="{{ camp.campID }}" href="/rv-campgrounds/{{ camp.administrative_area_level_1_long }}/{{ camp.city| quote_plus | lower | replace("+","-) }}/{{ camp.camp_name| quote_plus | lower | replace("+","-) }}">',
	'	  <a class="start-0 w-100 h-100 position-absolute zindex-0" onclick="return false" tab-index="-1" role="button" target="_blank" href="/rv-campgrounds/{{ camp.administrative_area_level_1_long }}/{{ camp.city| quote_plus | lower | replace("+","-) }}/{{ camp.camp_name| quote_plus | lower | replace("+","-) }}"></a>',
	'	  <div class="d-flex flex-column" style="width:80%;">',
	'		<h6 style="margin-bottom:0;">{{ camp.camp_name }}</h6>',
	'		<div class="d-flex flex-row align-items-center">',
	'		  <h6 class="fs-sm" style="font-weight:400;margin-bottom:0;">{{ camp.city }}, {{ camp.administrative_area_level_1 }}',
	'			</h6>',
	'		</div>',
	'	  </div>',
	'	  <div class="d-flex flex-row justify-content-end flex-wrap align-items-center">',
	'			<div class="d-flex flex-row align-items-center">',
	'				<img class="pe-1" src ="/static/images/icons/JUSTtheSTARS.svg" style="height:22px;pointer-events:none;"></img>',
	'				<h6 style="font-weight:400;margin-bottom:0;padding-top:.125rem;">{{ camp.genie_score }}</h6>',
	'			</div>',
	'		<a class="zindex-1" data-bs-toggle="tooltip" data-bs-placement="right" title="Remove Stay" role="button" removestaybutton="removeStayButton"><i style="padding-bottom:.125rem;" class="ai-trash-2 ps-1 agIcon"></i></a>',
	'	  </div>',
	'	</div>',
	'	<div class="px-2 mt-n2 pb-2 d-flex justify-content-start w-100 align-items-start">',
	'		<img id="s2n-logo" class="containImage" style="height:12px;width:fit-content;" src="/static/images/s2n-logo-svg.svg">',
	'	</div>',
	'  </div>'
].join("\n");

export const selectedStayTemplate_sideMenu_NOGENIESCORE = [
	'	<div campStayElement="" leg="{{ legIndex }}" stop="{{ stopIndex }}" class="card p-2 mb-2" campID="{{ camp.campID }}">',
	'	<div class="card-body p-2 d-flex flex-row camp-card-body justify-content-between" leg="{{ legIndex }}" stop="{{ stopIndex }}" id="{{ camp.campID }}" href="/rv-campgrounds/{{ camp.administrative_area_level_1_long }}/{{ camp.city| quote_plus | lower | replace("+","-) }}/{{ camp.camp_name| quote_plus | lower | replace("+","-) }}">',
	'	  <a class="start-0 w-100 h-100 position-absolute zindex-0" onclick="return false" tab-index="-1" role="button" target="_blank" href="/rv-campgrounds/{{ camp.administrative_area_level_1_long }}/{{ camp.city| quote_plus | lower | replace("+","-) }}/{{ camp.camp_name| quote_plus | lower | replace("+","-) }}"></a>',
	'	  <div class="d-flex flex-column" style="width:70%;">',
	'		<h6 style="margin-bottom:0;" campsite_name>{{ camp.camp_name }}</h6>',
	'		<div class="d-flex flex-row align-items-center">',
	'		  <h6 class="fs-sm" style="font-weight:400;margin-bottom:0;">{{ camp.city }}, {{ camp.administrative_area_level_1 }}',
	'			</h6>',
	'		</div>',
	'	  </div>',
	'	  <div class="d-flex flex-row flex-wrap justify-content-end ms-2 align-items-center">',
	'			<div class="d-flex flex-row align-items-center">',
	'				<img class="pe-1" src ="/static/images/icons/genieMatch.svg" style="height:22px;pointer-events:none;"></img>',
	'				<h6 style="font-weight:400;margin-bottom:0;padding-top:.125rem;" class="campsite-match">{{ camp.genieMatch }}%</h6>',
	'			</div>',
	'		<a class="zindex-1" data-bs-toggle="tooltip" data-bs-placement="right" title="Remove Stay" role="button" removestaybutton="removeStayButton"><i style="padding-bottom:.125rem;" class="ai-trash-2 ps-1 agIcon"></i></a>',
	'	  </div>',
	'	</div>',
	'  </div>'
].join("\n");

export const selectedStayTemplate_sideMenu_NOGENIESCORE_S2N = [
	'	<div campStayElement="" leg="{{ legIndex }}" stop="{{ stopIndex }}" class="card p-2 mb-2" campID="{{ camp.campID }}">',
	'	<div class="card-body p-2 d-flex flex-row camp-card-body justify-content-between" leg="{{ legIndex }}" stop="{{ stopIndex }}" id="{{ camp.campID }}" href="/rv-campgrounds/{{ camp.administrative_area_level_1_long }}/{{ camp.city| quote_plus | lower | replace("+","-) }}/{{ camp.camp_name| quote_plus | lower | replace("+","-) }}">',
	'	  <a class="start-0 w-100 h-100 position-absolute zindex-0" onclick="return false" tab-index="-1" role="button" target="_blank" href="/rv-campgrounds/{{ camp.administrative_area_level_1_long }}/{{ camp.city| quote_plus | lower | replace("+","-) }}/{{ camp.camp_name| quote_plus | lower | replace("+","-) }}"></a>',
	'	  <div class="d-flex flex-column" style="width:70%;">',
	'		<h6 style="margin-bottom:0;" campsite_name>{{ camp.camp_name }}</h6>',
	'		<div class="d-flex flex-row align-items-center">',
	'		  <h6 class="fs-sm" style="font-weight:400;margin-bottom:0;">{{ camp.city }}, {{ camp.administrative_area_level_1 }}',
	'			</h6>',
	'		</div>',
	'	  </div>',
	'	  <div class="d-flex flex-row flex-wrap justify-content-end ms-2 align-items-center">',
	'			<div class="d-flex flex-row align-items-center">',
	'				<img class="pe-1" src ="/static/images/icons/genieMatch.svg" style="height:22px;pointer-events:none;"></img>',
	'				<h6 style="font-weight:400;margin-bottom:0;padding-top:.125rem;" class="campsite-match">{{ camp.genieMatch }}%</h6>',
	'			</div>',
	'		<a class="zindex-1" data-bs-toggle="tooltip" data-bs-placement="right" title="Remove Stay" role="button" removestaybutton="removeStayButton"><i style="padding-bottom:.125rem;" class="ai-trash-2 ps-1 agIcon"></i></a>',
	'	  </div>',
	'	</div>',
	'	<div class="px-2 mt-n2 pb-2 d-flex justify-content-start w-100 align-items-start">',
	'		<img id="s2n-logo" class="containImage" style="height:12px;width:fit-content;" src="/static/images/s2n-logo-svg.svg">',
	'	</div>',
	'  </div>'
].join("\n");

export const selectedStayTemplate_sideMenu_NOGENIESCORE_NOGENIEMATCH = [
	'	<div campStayElement="" leg="{{ legIndex }}" stop="{{ stopIndex }}" class="card p-2 mb-2" campID="{{ camp.campID }}">',
	'	<div class="card-body p-2 d-flex flex-row camp-card-body justify-content-between" leg="{{ legIndex }}" stop="{{ stopIndex }}" id="{{ camp.campID }}" href="/rv-campgrounds/{{ camp.administrative_area_level_1_long }}/{{ camp.city| quote_plus | lower | replace("+","-) }}/{{ camp.camp_name| quote_plus | lower | replace("+","-) }}">',
	'	  <a class="start-0 w-100 h-100 position-absolute zindex-0" onclick="return false" tab-index="-1" role="button" target="_blank" href="/rv-campgrounds/{{ camp.administrative_area_level_1_long }}/{{ camp.city| quote_plus | lower | replace("+","-) }}/{{ camp.camp_name| quote_plus | lower | replace("+","-) }}"></a>',
	'	  <div class="d-flex flex-column" style="width:90%;">',
	'		<h6 style="margin-bottom:0;" campsite_name>{{ camp.camp_name }}</h6>',
	'		<div class="d-flex flex-row align-items-center">',
	'		  <h6 class="fs-sm" style="font-weight:400;margin-bottom:0;">{{ camp.city }}, {{ camp.administrative_area_level_1 }}',
	'			</h6>',
	'		</div>',
	'	  </div>',
	'	  <div class="d-flex flex-row ms-2 align-items-center">',
	'		<a class="zindex-1" data-bs-toggle="tooltip" data-bs-placement="right" title="Remove Stay" role="button" removestaybutton="removeStayButton"><i style="padding-bottom:.125rem;" class="ai-trash-2 ps-1 agIcon"></i></a>',
	'	  </div>',
	'	</div>',
	'  </div>'
].join("\n");

export const selectedStayTemplate_sideMenu_NOGENIESCORE_NOGENIEMATCH_S2N = [
	'	<div campStayElement="" leg="{{ legIndex }}" stop="{{ stopIndex }}" class="card p-2 mb-2" campID="{{ camp.campID }}">',
	'	<div class="card-body p-2 d-flex flex-row camp-card-body justify-content-between" leg="{{ legIndex }}" stop="{{ stopIndex }}" id="{{ camp.campID }}" href="/rv-campgrounds/{{ camp.administrative_area_level_1_long }}/{{ camp.city| quote_plus | lower | replace("+","-) }}/{{ camp.camp_name| quote_plus | lower | replace("+","-) }}">',
	'	  <a class="start-0 w-100 h-100 position-absolute zindex-0" onclick="return false" tab-index="-1" role="button" target="_blank" href="/rv-campgrounds/{{ camp.administrative_area_level_1_long }}/{{ camp.city| quote_plus | lower | replace("+","-) }}/{{ camp.camp_name| quote_plus | lower | replace("+","-) }}"></a>',
	'	  <div class="d-flex flex-column" style="width:90%;">',
	'		<h6 style="margin-bottom:0;" campsite_name>{{ camp.camp_name }}</h6>',
	'		<div class="d-flex flex-row align-items-center">',
	'		  <h6 class="fs-sm" style="font-weight:400;margin-bottom:0;">{{ camp.city }}, {{ camp.administrative_area_level_1 }}',
	'			</h6>',
	'		</div>',
	'	  </div>',
	'	  <div class="d-flex flex-row ms-2 align-items-center">',
	'		<a class="zindex-1" data-bs-toggle="tooltip" data-bs-placement="right" title="Remove Stay" role="button" removestaybutton="removeStayButton"><i style="padding-bottom:.125rem;" class="ai-trash-2 ps-1 agIcon"></i></a>',
	'	  </div>',
	'	</div>',
	'	<div class="px-2 mt-n2 pb-2 d-flex justify-content-start w-100 align-items-start">',
	'		<img id="s2n-logo" class="containImage" style="height:12px;width:fit-content;" src="/static/images/s2n-logo-svg.svg">',
	'	</div>',
	'  </div>'
].join("\n");

export const selectedStayTemplate_sideMenu_NOGENIESCORE_customstay = [
	'	<div campStayElement="" leg="{{ legIndex }}" stop="{{ stopIndex }}" class="card p-2 mb-2" campID="{{ camp.campID }}">',
	'	<div class="card-body p-2 d-flex justify-content-between flex-row" id="{{ camp.campID }}" href="/rv-campgrounds/{{ camp.administrative_area_level_1_long }}/{{ camp.city| quote_plus | lower | replace("+","-) }}/{{ camp.camp_name| quote_plus | lower | replace("+","-) }}">',
	'	  <a class="start-0 w-100 h-100 position-absolute zindex-0" onclick="return false" tab-index="-1" role="button" target="_blank" href="/rv-campgrounds/{{ camp.administrative_area_level_1_long }}/{{ camp.city| quote_plus | lower | replace("+","-) }}/{{ camp.camp_name| quote_plus | lower | replace("+","-) }}"></a>',
	'	  <div class="d-flex flex-column" style="width:70%;">',
	'		<h6 style="margin-bottom:0;">{{ camp.camp_name }}</h6>',
	'		<div class="d-flex flex-row align-items-center">',
	'		  <h6 class="fs-sm" style="font-weight:400;margin-bottom:0;">{{ camp.city }} {{ camp.administrative_area_level_1 }}',
	'			</h6>',
	'		</div>',
	'	  </div>',
	'	  <div class="d-flex flex-row flex-wrap justify-content-end ms-2 align-items-center">',
	'			<div class="d-flex flex-row align-items-center">',
	'				<img class="pe-1" src ="/static/images/icons/genieMatch.svg" style="height:22px;pointer-events:none;"></img>',
	'				<h6 style="font-weight:400;margin-bottom:0;padding-top:.125rem;" class="campsite-match">{{ camp.genieMatch }}%</h6>',
	'			</div>',
	'		<a class="zindex-1" data-bs-toggle="tooltip" data-bs-placement="right" title="Remove Stay" role="button" removestaybutton="removeStayButton"><i style="padding-bottom:.125rem;" class="ai-trash-2 ps-1 agIcon"></i></a>',
	'	  </div>',
	'	</div>',
	'  </div>'
].join("\n");

export const selectedStayTemplate_sideMenu_NOGENIESCORE_NOGENIEMATCH_customstay = [
	'	<div campStayElement="" leg="{{ legIndex }}" stop="{{ stopIndex }}" class="card p-2 mb-2" campID="{{ camp.campID }}">',
	'	<div class="card-body p-2 d-flex justify-content-between flex-row" id="{{ camp.campID }}" href="/rv-campgrounds/{{ camp.administrative_area_level_1_long }}/{{ camp.city| quote_plus | lower | replace("+","-) }}/{{ camp.camp_name| quote_plus | lower | replace("+","-) }}">',
	'	  <a class="start-0 w-100 h-100 position-absolute zindex-0" onclick="return false" tab-index="-1" role="button" target="_blank" href="/rv-campgrounds/{{ camp.administrative_area_level_1_long }}/{{ camp.city| quote_plus | lower | replace("+","-) }}/{{ camp.camp_name| quote_plus | lower | replace("+","-) }}"></a>',
	'	  <div class="d-flex flex-column" style="width:90%;">',
	'		<h6 style="margin-bottom:0;">{{ camp.camp_name }}</h6>',
	'		<div class="d-flex flex-row align-items-center">',
	'		  <h6 class="fs-sm" style="font-weight:400;margin-bottom:0;">{{ camp.city }} {{ camp.administrative_area_level_1 }}',
	'			</h6>',
	'		</div>',
	'	  </div>',
	'	  <div class="d-flex flex-row ms-2 align-items-center">',
	'		<a class="zindex-1" data-bs-toggle="tooltip" data-bs-placement="right" title="Remove Stay" role="button" removestaybutton="removeStayButton"><i style="padding-bottom:.125rem;" class="ai-trash-2 ps-1 agIcon"></i></a>',
	'	  </div>',
	'	</div>',
	'  </div>'
].join("\n");

export const recommendedCamp_card = [
	'	<div class="card p-2 mb-2 px-6" campID="{{ camp.campID }}" recommendedCamp="">',
	'	<div role="button" class="card-body p-2 d-flex flex-row camp-card-body justify-content-between" unSelStay="" id="{{ camp.campID }}" leg="{{ legIndex }}" stop="{{ stopIndex }}">',
	'	  <div class="d-flex flex-column justify-content-center" style="width:70%;">',
	'		<h6 class="text-start" style="margin-bottom:0;" campsite_name>{{ camp.camp_name }}</h6>',
	'		<div class="d-flex flex-row align-items-center">',
	'		  <h6 class="fs-sm" style="font-weight:400;margin-bottom:0;">{{ camp.city }}, {{ camp.administrative_area_level_1 }}</h6>',
	'		</div>',
	'		<p class="mb-0 text-start fs-xs">{{ dist_str }}</p>',
	'	  </div>',
	'	  <div class="d-flex flex-row justify-content-end flex-wrap gap-2 align-items-center">',
	'			<div class="d-flex flex-row align-items-center">',
	'				<img class="pe-1" src="/static/images/icons/JUSTtheSTARS.svg" style="height:22px;pointer-events:none;">',
	'				<h6 style="font-weight:400;margin-bottom:0;padding-top:.125rem;" class="campsite-rating">{{ camp.genie_score }}</h6>',
	'			</div>',
	'			<div class="d-flex flex-row align-items-center">',
	'				<img class="pe-1" src ="/static/images/icons/genieMatch.svg" style="height:22px;pointer-events:none;"></img>',
	'				<h6 style="font-weight:400;margin-bottom:0;padding-top:.125rem;" class="campsite-match">{{ camp.genieMatch }}%</h6>',
	'			</div>',
	'			<a {{{ addStayAttr }}} leg="{{ legIndex }}" stop="{{ stopIndex }}" campID="{{ camp.campID }}" style="text-decoration:none;" class="d-flex flex-column h-100 align-items-center justify-content-center agButtonGreenAdd">',
	'				<i class="ai-plus-square"></i>',
	'			</a>',
	'	  </div>',
	'	</div>',
	'  </div>'
].join("\n");

export const stayTemplate_sideMenu = [
'	<div stayElement="" class="card campsite-card p-2 mb-2" campID="{{ camp.campID }}">',
'		<div class="amenity-list d-none">{{ amenities }}</div>',
'		<div class="activity-list d-none">{{ activities }}</div>',
'		<div class="discounts d-none">{{ discounts }}</div>',
'		<div class="affiliates d-none">{{ affiliations }}</div>',
'		<div class="campground-sites d-none">{{ camp.num_sites }}</div>',
'		<div class="campgrounds-price d-none">{{ camp.price_low }},{{ camp.price_high }}</div>',
'		<div class="campground-rvlw d-none">{{ camp.max_RV_length }},{{ camp.max_RV_width }}</div>',
'	<div role="button" class="card-body p-2 d-flex flex-row camp-card-body justify-content-between", unSelStay="" id="{{ camp.campID }}" leg="{{ legIndex }}" stop="{{ stopIndex }}" href="/rv-campgrounds/{{ camp.administrative_area_level_1_long }}/{{ camp.city| quote_plus | lower | replace("+","-) }}/{{ camp.camp_name| quote_plus | lower | replace("+","-) }}">',
'	  <div class="d-flex flex-column justify-content-center" style="width:70%;">',
'		<h6 style="margin-bottom:0;" campsite_name>{{ camp.camp_name }}</h6>',
'		<div class="d-flex flex-row align-items-center">',
'		  <h6 class="fs-sm" style="font-weight:400;margin-bottom:0;">{{ camp.city }}, {{ camp.administrative_area_level_1 }} |',
'			</h6>',
'		  <p class="fs-xs my-0 ps-2" distToStop>Dist To Stop: {{ dist }}mi</p>',
'		</div>',
'	  </div>',
'	  <div class="d-flex flex-row justify-content-end flex-wrap gap-2 align-items-center">',
'			<div class="d-flex flex-row align-items-center">',
'				<img class="pe-1" src ="/static/images/icons/JUSTtheSTARS.svg" style="height:22px;pointer-events:none;"></img>',
'				<h6 style="font-weight:400;margin-bottom:0;padding-top:.125rem;" class="campsite-rating">{{ camp.genie_score }}</h6>',
'			</div>',
'			<div class="d-flex flex-row align-items-center">',
'				<img class="pe-1" src ="/static/images/icons/genieMatch.svg" style="height:22px;pointer-events:none;"></img>',
'				<h6 style="font-weight:400;margin-bottom:0;padding-top:.125rem;" class="campsite-match">{{ camp.genieMatch }}%</h6>',
'			</div>',
'			<a {{{ addStayAttr }}} leg="{{ legIndex }}" stop="{{ stopIndex }}" campID="{{ camp.campID }}" style="text-decoration:none;" class="d-flex flex-column h-100 align-items-center justify-content-center agButtonGreenAdd">',
'				<i class="ai-plus-square"></i>',
'			</a>',
'	  </div>',
'	</div>',
'  </div>'
].join("\n");

export const stayTemplate_sideMenu_NOGENIEMATCH = [
'	<div stayElement="" class="card campsite-card p-2 mb-2" campID="{{ camp.campID }}">',
'		<div class="amenity-list d-none">{{ amenities }}</div>',
'		<div class="activity-list d-none">{{ activities }}</div>',
'		<div class="discounts d-none">{{ discounts }}</div>',
'		<div class="affiliates d-none">{{ affiliations }}</div>',
'		<div class="campground-sites d-none">{{ camp.num_sites }}</div>',
'		<div class="campgrounds-price d-none">{{ camp.price_low }},{{ camp.price_high }}</div>',
'		<div class="campground-rvlw d-none">{{ camp.max_RV_length }},{{ camp.max_RV_width }}</div>',
'	<div role="button" class="card-body p-2 d-flex flex-row camp-card-body justify-content-between", unSelStay="" id="{{ camp.campID }}" leg="{{ legIndex }}" stop="{{ stopIndex }}" href="/rv-campgrounds/{{ camp.administrative_area_level_1_long }}/{{ camp.city| quote_plus | lower | replace("+","-) }}/{{ camp.camp_name| quote_plus | lower | replace("+","-) }}">',
'	  <div class="d-flex flex-column justify-content-center" style="width:70%;">',
'		<h6 style="margin-bottom:0;" campsite_name>{{ camp.camp_name }}</h6>',
'		<div class="d-flex flex-row align-items-center">',
'		  <h6 class="fs-sm" style="font-weight:400;margin-bottom:0;">{{ camp.city }}, {{ camp.administrative_area_level_1 }} |',
'			</h6>',
'		  <p class="fs-xs my-0 ps-2" distToStop>Dist To Stop: {{ dist }}mi</p>',
'		</div>',
'	  </div>',
'	  <div class="d-flex flex-row justify-content-end flex-wrap gap-2 align-items-center">',
'			<div class="d-flex flex-row align-items-center">',
'				<img class="pe-1" src ="/static/images/icons/JUSTtheSTARS.svg" style="height:22px;pointer-events:none;"></img>',
'				<h6 style="font-weight:400;margin-bottom:0;padding-top:.125rem;" class="campsite-rating">{{ camp.genie_score }}</h6>',
'			</div>',
'			<a {{{ addStayAttr }}} leg="{{ legIndex }}" stop="{{ stopIndex }}" campID="{{ camp.campID }}" style="text-decoration:none;" class="d-flex flex-column h-100 align-items-center justify-content-center agButtonGreenAdd">',
'				<i class="ai-plus-square"></i>',
'			</a>',
'	  </div>',
'	</div>',
'  </div>'
].join("\n");

export const stayTemplate_sideMenu_NOGENIESCORE = [
'	<div stayElement="" class="card campsite-card p-2 mb-2" campID="{{ camp.campID }}">',
'		<div class="amenity-list d-none">{{ amenities }}</div>',
'		<div class="activity-list d-none">{{ activities }}</div>',
'		<div class="discounts d-none">{{ discounts }}</div>',
'		<div class="affiliates d-none">{{ affiliations }}</div>',
'		<div class="campground-sites d-none">{{ camp.num_sites }}</div>',
'		<div class="campgrounds-price d-none">{{ camp.price_low }},{{ camp.price_high }}</div>',
'		<div class="campground-rvlw d-none">{{ camp.max_RV_length }},{{ camp.max_RV_width }}</div>',
'	<div role="button" class="card-body p-2 d-flex flex-row camp-card-body justify-content-between", unSelStay="" id="{{ camp.campID }}" leg="{{ legIndex }}" stop="{{ stopIndex }}" href="/rv-campgrounds/{{ camp.administrative_area_level_1_long }}/{{ camp.city| quote_plus | lower | replace("+","-) }}/{{ camp.camp_name| quote_plus | lower | replace("+","-) }}">',
'	  <div class="d-flex flex-column justify-content-center" style="width:70%;">',
'		<h6 style="margin-bottom:0;" campsite_name>{{ camp.camp_name }}</h6>',
'		<div class="d-flex flex-row align-items-center">',
'		  <h6 class="fs-sm" style="font-weight:400;margin-bottom:0;">{{ camp.city }}, {{ camp.administrative_area_level_1 }} |',
'			</h6>',
'		  <p class="fs-xs my-0 ps-2" distToStop>Dist To Stop: {{ dist }}mi</p>',
'		</div>',
'	  </div>',
'	  <div class="d-flex flex-row ms-2 gap-2 align-items-center flex-wrap justify-content-end">',
'			<div class="d-flex flex-row align-items-center">',
'				<img class="pe-1" src ="/static/images/icons/genieMatch.svg" style="height:22px;pointer-events:none;"></img>',
'				<h6 style="font-weight:400;margin-bottom:0;padding-top:.125rem;" class="campsite-match">{{ camp.genieMatch }}%</h6>',
'			</div>',
'			<a {{{ addStayAttr }}} leg="{{ legIndex }}" stop="{{ stopIndex }}" campID="{{ camp.campID }}" style="text-decoration:none;" class="d-flex flex-column h-100 align-items-center justify-content-center agButtonGreenAdd">',
'				<i class="ai-plus-square"></i>',
'			</a>',
'	  </div>',
'	</div>',
'  </div>'
].join("\n");

export const stayTemplate_sideMenu_NOGENIESCORE_NOGENIEMATCH = [
	'	<div stayElement="" class="card campsite-card p-2 mb-2" campID="{{ camp.campID }}">',
	'		<div class="amenity-list d-none">{{ amenities }}</div>',
	'		<div class="activity-list d-none">{{ activities }}</div>',
	'		<div class="discounts d-none">{{ discounts }}</div>',
	'		<div class="affiliates d-none">{{ affiliations }}</div>',
	'		<div class="campground-sites d-none">{{ camp.num_sites }}</div>',
	'		<div class="campgrounds-price d-none">{{ camp.price_low }},{{ camp.price_high }}</div>',
	'		<div class="campground-rvlw d-none">{{ camp.max_RV_length }},{{ camp.max_RV_width }}</div>',
	'	<div role="button" class="card-body p-2 d-flex flex-row camp-card-body justify-content-between", unSelStay="" id="{{ camp.campID }}" leg="{{ legIndex }}" stop="{{ stopIndex }}" href="/rv-campgrounds/{{ camp.administrative_area_level_1_long }}/{{ camp.city| quote_plus | lower | replace("+","-) }}/{{ camp.camp_name| quote_plus | lower | replace("+","-) }}">',
	'	  <div class="d-flex flex-column justify-content-center" style="width:90%;">',
	'		<h6 style="margin-bottom:0;" campsite_name>{{ camp.camp_name }}</h6>',
	'		<div class="d-flex flex-row align-items-center">',
	'		  <h6 class="fs-sm" style="font-weight:400;margin-bottom:0;">{{ camp.city }}, {{ camp.administrative_area_level_1 }} |',
	'			</h6>',
	'		  <p class="fs-xs my-0 ps-2" distToStop>Dist To Stop: {{ dist }}mi</p>',
	'		</div>',
	'	  </div>',
	'	  <div class="d-flex flex-row ms-2 gap-2 align-items-center">',
	'			<a {{{ addStayAttr }}} leg="{{ legIndex }}" stop="{{ stopIndex }}" campID="{{ camp.campID }}" style="text-decoration:none;" class="d-flex flex-column h-100 align-items-center justify-content-center agButtonGreenAdd">',
	'				<i class="ai-plus-square"></i>',
	'			</a>',
	'	  </div>',
	'	</div>',
	'  </div>'
	].join("\n");

export const stayTemplate_sideMenu_S2N = [
'	<div stayElement="" class="card campsite-card p-2 mb-2" campID="{{ camp.campID }}">',
'		<div class="amenity-list d-none">{{ amenities }}</div>',
'		<div class="activity-list d-none">{{ activities }}</div>',
'		<div class="discounts d-none">{{ discounts }}</div>',
'		<div class="affiliates d-none">{{ affiliations }}</div>',
'		<div class="campground-sites d-none">{{ camp.num_sites }}</div>',
'		<div class="campgrounds-price d-none">{{ camp.price_low }},{{ camp.price_high }}</div>',
'		<div class="campground-rvlw d-none">{{ camp.max_RV_length }},{{ camp.max_RV_width }}</div>',
'	<div role="button" class="card-body p-2 d-flex flex-row camp-card-body justify-content-between", unSelStay="" id="{{ camp.campID }}" leg="{{ legIndex }}" stop="{{ stopIndex }}" href="/rv-campgrounds/{{ camp.administrative_area_level_1_long }}/{{ camp.city| quote_plus | lower | replace("+","-) }}/{{ camp.camp_name| quote_plus | lower | replace("+","-) }}">',
'	  <div class="d-flex flex-column justify-content-center" style="width:70%;">',
'		<h6 style="margin-bottom:0;" campsite_name>{{ camp.camp_name }}</h6>',
'		<div class="d-flex flex-row align-items-center">',
'		  <h6 class="fs-sm" style="font-weight:400;margin-bottom:0;">{{ camp.city }}, {{ camp.administrative_area_level_1 }} |',
'			</h6>',
'		  <p class="fs-xs my-0 ps-2" distToStop>Dist To Stop: {{ dist }}mi</p>',
'		</div>',
'	  </div>',
'	  <div class="d-flex flex-row justify-content-end flex-wrap gap-2 align-items-center">',
'			<div class="d-flex flex-row align-items-center">',
'				<img class="pe-1" src ="/static/images/icons/JUSTtheSTARS.svg" style="height:22px;pointer-events:none;"></img>',
'				<h6 style="font-weight:400;margin-bottom:0;padding-top:.125rem;" class="campsite-rating">{{ camp.genie_score }}</h6>',
'			</div>',
'			<div class="d-flex flex-row align-items-center">',
'				<img class="pe-1" src ="/static/images/icons/genieMatch.svg" style="height:22px;pointer-events:none;"></img>',
'				<h6 style="font-weight:400;margin-bottom:0;padding-top:.125rem;" class="campsite-match">{{ camp.genieMatch }}%</h6>',
'			</div>',
'			<a {{{ addStayAttr }}} leg="{{ legIndex }}" stop="{{ stopIndex }}" campID="{{ camp.campID }}" style="text-decoration:none;" class="d-flex flex-column h-100 align-items-center justify-content-center agButtonGreenAdd">',
'				<i class="ai-plus-square"></i>',
'			</a>',
'	  </div>',
'	</div>',
'<div class="px-2 mt-n2 pb-2 d-flex justify-content-start w-100 align-items-start">',
'	<img id="s2n-logo" class="containImage" style="height:12px;width:fit-content;" src="/static/images/s2n-logo-svg.svg"/>',
'</div>',
'  </div>'
].join("\n");

export const stayTemplate_sideMenu_NOGENIEMATCH_S2N = [
'	<div stayElement="" class="card campsite-card p-2 mb-2" campID="{{ camp.campID }}">',
'		<div class="amenity-list d-none">{{ amenities }}</div>',
'		<div class="activity-list d-none">{{ activities }}</div>',
'		<div class="discounts d-none">{{ discounts }}</div>',
'		<div class="affiliates d-none">{{ affiliations }}</div>',
'		<div class="campground-sites d-none">{{ camp.num_sites }}</div>',
'		<div class="campgrounds-price d-none">{{ camp.price_low }},{{ camp.price_high }}</div>',
'		<div class="campground-rvlw d-none">{{ camp.max_RV_length }},{{ camp.max_RV_width }}</div>',
'	<div role="button" class="card-body p-2 d-flex flex-row camp-card-body justify-content-between", unSelStay="" id="{{ camp.campID }}" leg="{{ legIndex }}" stop="{{ stopIndex }}" href="/rv-campgrounds/{{ camp.administrative_area_level_1_long }}/{{ camp.city| quote_plus | lower | replace("+","-) }}/{{ camp.camp_name| quote_plus | lower | replace("+","-) }}">',
'	  <div class="d-flex flex-column justify-content-center" style="width:70%;">',
'		<h6 style="margin-bottom:0;" campsite_name>{{ camp.camp_name }}</h6>',
'		<div class="d-flex flex-row align-items-center">',
'		  <h6 class="fs-sm" style="font-weight:400;margin-bottom:0;">{{ camp.city }}, {{ camp.administrative_area_level_1 }} |',
'			</h6>',
'		  <p class="fs-xs my-0 ps-2" distToStop>Dist To Stop: {{ dist }}mi</p>',
'		</div>',
'	  </div>',
'	  <div class="d-flex flex-row justify-content-end flex-wrap gap-2 align-items-center">',
'			<div class="d-flex flex-row align-items-center">',
'				<img class="pe-1" src ="/static/images/icons/JUSTtheSTARS.svg" style="height:22px;pointer-events:none;"></img>',
'				<h6 style="font-weight:400;margin-bottom:0;padding-top:.125rem;" class="campsite-rating">{{ camp.genie_score }}</h6>',
'			</div>',
'			<a {{{ addStayAttr }}} leg="{{ legIndex }}" stop="{{ stopIndex }}" campID="{{ camp.campID }}" style="text-decoration:none;" class="d-flex flex-column h-100 align-items-center justify-content-center agButtonGreenAdd">',
'				<i class="ai-plus-square"></i>',
'			</a>',
'	  </div>',
'	</div>',
'<div class="px-2 mt-n2 pb-2 d-flex justify-content-start w-100 align-items-start">',
'	<img id="s2n-logo" class="containImage" style="height:12px;width:fit-content;" src="/static/images/s2n-logo-svg.svg"/>',
'</div>',
'  </div>'
].join("\n");

export const stayTemplate_sideMenu_NOGENIESCORE_S2N = [
'	<div stayElement="" class="card campsite-card p-2 mb-2" campID="{{ camp.campID }}">',
'		<div class="amenity-list d-none">{{ amenities }}</div>',
'		<div class="activity-list d-none">{{ activities }}</div>',
'		<div class="discounts d-none">{{ discounts }}</div>',
'		<div class="affiliates d-none">{{ affiliations }}</div>',
'		<div class="campground-sites d-none">{{ camp.num_sites }}</div>',
'		<div class="campgrounds-price d-none">{{ camp.price_low }},{{ camp.price_high }}</div>',
'		<div class="campground-rvlw d-none">{{ camp.max_RV_length }},{{ camp.max_RV_width }}</div>',
'	<div role="button" class="card-body p-2 d-flex flex-row camp-card-body justify-content-between", unSelStay="" id="{{ camp.campID }}" leg="{{ legIndex }}" stop="{{ stopIndex }}" href="/rv-campgrounds/{{ camp.administrative_area_level_1_long }}/{{ camp.city| quote_plus | lower | replace("+","-) }}/{{ camp.camp_name| quote_plus | lower | replace("+","-) }}">',
'	  <div class="d-flex flex-column justify-content-center" style="width:70%;">',
'		<h6 style="margin-bottom:0;" campsite_name>{{ camp.camp_name }}</h6>',
'		<div class="d-flex flex-row align-items-center">',
'		  <h6 class="fs-sm" style="font-weight:400;margin-bottom:0;">{{ camp.city }}, {{ camp.administrative_area_level_1 }} |',
'			</h6>',
'		  <p class="fs-xs my-0 ps-2" distToStop>Dist To Stop: {{ dist }}mi</p>',
'		</div>',
'	  </div>',
'	  <div class="d-flex flex-row ms-2 gap-2 align-items-center flex-wrap justify-content-end">',
'			<div class="d-flex flex-row align-items-center">',
'				<img class="pe-1" src ="/static/images/icons/genieMatch.svg" style="height:22px;pointer-events:none;"></img>',
'				<h6 style="font-weight:400;margin-bottom:0;padding-top:.125rem;" class="campsite-match">{{ camp.genieMatch }}%</h6>',
'			</div>',
'			<a {{{ addStayAttr }}} leg="{{ legIndex }}" stop="{{ stopIndex }}" campID="{{ camp.campID }}" style="text-decoration:none;" class="d-flex flex-column h-100 align-items-center justify-content-center agButtonGreenAdd">',
'				<i class="ai-plus-square"></i>',
'			</a>',
'	  </div>',
'	</div>',
'<div class="px-2 mt-n2 pb-2 d-flex justify-content-start w-100 align-items-start">',
'	<img id="s2n-logo" class="containImage" style="height:12px;width:fit-content;" src="/static/images/s2n-logo-svg.svg"/>',
'</div>',
'  </div>'
].join("\n");

export const stayTemplate_sideMenu_NOGENIESCORE_NOGENIEMATCH_S2N = [
	'	<div stayElement="" class="card campsite-card p-2 mb-2" campID="{{ camp.campID }}">',
	'		<div class="amenity-list d-none">{{ amenities }}</div>',
	'		<div class="activity-list d-none">{{ activities }}</div>',
	'		<div class="discounts d-none">{{ discounts }}</div>',
	'		<div class="affiliates d-none">{{ affiliations }}</div>',
	'		<div class="campground-sites d-none">{{ camp.num_sites }}</div>',
	'		<div class="campgrounds-price d-none">{{ camp.price_low }},{{ camp.price_high }}</div>',
	'		<div class="campground-rvlw d-none">{{ camp.max_RV_length }},{{ camp.max_RV_width }}</div>',
	'	<div role="button" class="card-body p-2 d-flex flex-row camp-card-body justify-content-between", unSelStay="" id="{{ camp.campID }}" leg="{{ legIndex }}" stop="{{ stopIndex }}" href="/rv-campgrounds/{{ camp.administrative_area_level_1_long }}/{{ camp.city| quote_plus | lower | replace("+","-) }}/{{ camp.camp_name| quote_plus | lower | replace("+","-) }}">',
	'	  <div class="d-flex flex-column justify-content-center" style="width:90%;">',
	'		<h6 style="margin-bottom:0;" campsite_name>{{ camp.camp_name }}</h6>',
	'		<div class="d-flex flex-row align-items-center">',
	'		  <h6 class="fs-sm" style="font-weight:400;margin-bottom:0;">{{ camp.city }}, {{ camp.administrative_area_level_1 }} |',
	'			</h6>',
	'		  <p class="fs-xs my-0 ps-2" distToStop>Dist To Stop: {{ dist }}mi</p>',
	'		</div>',
	'	  </div>',
	'	  <div class="d-flex flex-row ms-2 gap-2 align-items-center">',
	'			<a {{{ addStayAttr }}} leg="{{ legIndex }}" stop="{{ stopIndex }}" campID="{{ camp.campID }}" style="text-decoration:none;" class="d-flex flex-column h-100 align-items-center justify-content-center agButtonGreenAdd">',
	'				<i class="ai-plus-square"></i>',
	'			</a>',
	'	  </div>',
	'	</div>',
	'<div class="px-2 mt-n2 pb-2 d-flex justify-content-start w-100 align-items-start">',
'	<img id="s2n-logo" class="containImage" style="height:12px;width:fit-content;" src="/static/images/s2n-logo-svg.svg"/>',
'</div>',
	'  </div>'
	].join("\n");

export const customStayTemplate_sideMenu = [
	'	<div campStayElement="" leg="{{ legIndex }}" stop="{{ stopIndex }}" class="card p-2 mb-2" campID="{{ camp.campID }}">',
	'	<div class="card-body p-2 d-flex flex-row camp-card-body justify-content-between" leg="{{ legIndex }}" stop="{{ stopIndex }}" id="{{ camp.campID }}">',
	'	  <div class="d-flex flex-column" style="width:90%;">',
	'		<h6 style="margin-bottom:0;">{{ camp.camp_name }}</h6>',
	'	  </div>',
	'	  <div class="d-flex flex-row ms-2 align-items-center">',
	'		<a class="zindex-1" data-bs-toggle="tooltip" data-bs-placement="right" title="Remove Stay" role="button" removestaybutton="removeStayButton"><i style="padding-bottom:.125rem;" class="ai-trash-2 ps-1 agIcon"></i></a>',
	'	  </div>',
	'	</div>',
	'  </div>'
].join("\n");

export const stopDatePicker_inputGroup = [
'<div class="input-group">',
'	<span class="input-group-text rounded-top-0 rounded-bottom-0"><i datepickericon="" class="ai-calendar"></i></span>',
'	<input class="form-control bg-white rounded-top-0 rounded-bottom-0" stopdatepicker="stopDatePicker" leg="{{ legIndex }}" stop="{{ stopIndex }}" autocomplete="off" type="text" placeholder="Select Dates"/>',
'	<span class="input-group-text rounded-top-0 rounded-bottom-right bg-primary" style="display:none;" data-bs-toggle="tooltip" stopdatewarning="stopDateWarning" leg="{{ legIndex }}" stop="{{ stopIndex }}">',
'		<i class="ai-alert-triangle text-white fs-xl"></i>',
'	</span>',
'</div>'
].join("\n");

export const stayDatePicker_inputGroup = [
'<div class="input-group">',
'	<span class="input-group-text rounded-top-0 rounded-bottom-left"><i datepickericon="" class="ai-calendar"></i></span>',
'	<input class="form-control bg-white rounded-top-0 rounded-bottom-right" staydatepicker="stayDatePicker" leg="{{ legIndex }}" stop="{{ stopIndex }}" campID="{{ campID }}" autocomplete="off" type="text" placeholder="Select Dates"/>',
'	<span class="input-group-text rounded-top-0 rounded-bottom-right bg-primary" style="display:none;" data-bs-toggle="tooltip" staydatewarning="stayDateWarning" leg="{{ legIndex }}" stop="{{ stopIndex }}" campid="{{ campID }}">',
'		<i class="ai-alert-triangle text-white fs-xl"></i>',
'	</span>',
'</div>',
].join("\n");

export const poiDatePicker_inputGroup = [
	'<div class="input-group">',
	'	<span class="input-group-text rounded-top-0 rounded-bottom-left"><i datepickericon="" class="ai-calendar"></i></span>',
	'	<input class="form-control bg-white rounded-top-0 rounded-bottom-right" poidatepicker="poiDatePicker" leg="{{ legIndex }}" stop="{{ stopIndex }}" poiID="{{ poiID }}" autocomplete="off" type="text" placeholder="Select Dates"/>',
	'	<span class="input-group-text rounded-top-0 rounded-bottom-right bg-primary" style="display:none;" data-bs-toggle="tooltip" poidatewarning="poiDateWarning" leg="{{ legIndex }}" stop="{{ stopIndex }}" poiID="{{ poiID }}">',
	'		<i class="ai-alert-triangle text-white fs-xl"></i>',
	'	</span>',
	'</div>',
	].join("\n");

export const customStayTemplate_mainDisp = [
'	<div class="d-flex flex-row mb-1" campstayelement="campStayElement" leg="{{ legIndex }}" stop="{{ stopIndex }}" campID="{{ camp.campID }}">',
'	<div class="d-flex flex-column ps-3 pb-5 agStayLine" style="width:10%;padding-bottom:2.5rem;">',
'	  <div class="d-flex flex-row w-100 h-100">',
'		<div class="d-flex w-50 h-100 rightBorderLine"></div>',
'		<div class="d-flex w-50 h-100"></div>',
'	  </div>',
'	  <div class="d-flex flex-row w-100 h-100">',
'		<div class="d-flex w-50 h-100 rightBorderLine"></div>',
'		<div class="d-flex w-50 h-100 bottomBorderLine"></div>',
'	  </div>',
'	</div>',
'	<div class="d-flex flex-column h-100 mt-3 UQcheck" staycardwrapper="stayCardWrapper" style="width:90%">',
'	  <div class="card card-hover p-3 rounded rounded-bottom-0">',
'		<div class="gap-1 justify-content-between d-flex flex-row zindex-1" id="{{ camp.campID }}">',
'		  <div class="d-flex flex-column justify-content-center" style="width:75%;">',
'			<h6 style="margin-bottom:0;">{{ camp.camp_name }}</h6>',
'		  </div>',
'			<div class="d-flex flex-row zindex-5 justify-content-end align-items-center" style="padding-bottom:.125rem;">',
'				<a leg="{{ legIndex }}" stop="{{ stopIndex }}" addstaybutton="addStayButton" data-bs-toggle="tooltip" data-bs-placement="right" title="Choose Another Campground" role="button">',
'					<i class="ai-git-pull-request agIcon" type="button"></i>',
'				</a>',
'				<a data-bs-toggle="tooltip" data-bs-placement="right" title="Remove Stay" role="button" removestaybutton="removeStayButton">',
'					<i class="ai-trash-2 agIcon ps-1" style="padding-bottom:.125rem"></i>',
'				</a>',
'			</div>',
'		</div>',
'	  </div>',
'	</div>',
'  </div>'
].join("\n");